import { withOverlayControls } from '@eventbrite/eds-structure';
import { getExperiment } from '@eventbrite/statsig';
import React from 'react';
import { connect } from 'react-redux';
import { useGetStatsigEnrollment } from '../../../../hooks';
import {
    DiscoverState,
    HeaderShape,
    HomepageBannerCTAExperiment,
    LocationState,
    UserShape,
} from '../../../../types';
import {
    ExperimentHomepageBannerCTAHeaderTitle,
    HeaderTitle,
} from '../../components/HeaderTitle';
import ExperimentBannerCTAOpensSearchScreen from '../../components/HeaderTitle/ExperimentBannerCTAOpensSearchScreen';
import { HomeEngagementExperimentTrackingLocations } from '../../constants/analytics';
import { clickCTASeasonal } from '../../redux/content/actions';
import { logToStatsigHomeEngagement } from '../../utils/analytics';
import { FullbleedHeaderBackgroundContainer } from '../FullbleedHeaderBackgroundContainer';
import './FullbleedHeader.scss';
interface FullbleedHeaderProps {
    location: LocationState;
    isLoading: boolean;
    history?: object;
    header: HeaderShape;
    clickCTASeasonal?: Function;
    user: UserShape;
}

export const FullbleedHeader = ({
    header,
    location,
    clickCTASeasonal,
    user,
}: FullbleedHeaderProps) => {
    const handleHeaderCTASeasonalClick = () => {
        logToStatsigHomeEngagement(
            HomeEngagementExperimentTrackingLocations.CITY_CTA,
            !!user.isAuthenticated,
        );
        clickCTASeasonal?.();
    };

    const homepageCTABannerVariant = useGetStatsigEnrollment({
        name: HomepageBannerCTAExperiment.name,
        paramName: HomepageBannerCTAExperiment.paramName,
        defaultValue: null,
    }).variant;

    let headerTitleComponent =
        homepageCTABannerVariant ===
        HomepageBannerCTAExperiment.values.location ? (
            <ExperimentHomepageBannerCTAHeaderTitle
                location={location}
                header={header}
                clickCTASeasonal={handleHeaderCTASeasonalClick}
                fullbleed={true}
            />
        ) : (
            <HeaderTitle
                header={header}
                clickCTASeasonal={handleHeaderCTASeasonalClick}
                fullbleed={true}
            />
        );

    const bannerButtonCta = getExperiment<boolean, boolean>(
        'banner_cta_opens_search_screen',
        'banner_cta_destination',
        false,
    );
    if (bannerButtonCta) {
        headerTitleComponent = (
            <ExperimentBannerCTAOpensSearchScreen header={header} />
        );
    }

    return (
        <section className="feed-fullbleed-header">
            <div className="feed-fullbleed-header__wrapper">
                <FullbleedHeaderBackgroundContainer
                    type="MainHeaderBackground"
                    isSeasonal={header?.shouldShowCustomContent}
                    placeholder={header?.headerImagePlaceholder}
                />

                <div className="feed-fullbleed-header__content">
                    <div className="eds-layout eds-layout--has-large-max-width eds-layout--has-horizontal-gutters">
                        <div className="eds-layout__body">
                            {headerTitleComponent}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const _mapStateToProps = ({ header, app, user, location }: DiscoverState) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
    user,
    location,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(FullbleedHeader),
);
